// @flow

import * as React from 'react';

import { Avatar } from '@ta/styleguide.avatar';
import { MemberName } from '@ta/social.member-common';
import type { MemberInfo } from '@ta/social.member-types';

import type { Profile } from '../types';

import styles from './IdentitySection.less';

type Props = {
  profile: Profile,
  memberInfo?: MemberInfo,
};

const IdentitySection = ({ profile, memberInfo }: Props) => (
  <div className={styles.identity_wrap}>
    <div className={styles.identity_block}>
      <div className={styles.avatar_wrap}>
        <Avatar photo={profile.avatar} withBorder />
      </div>
      <div className={styles.member_name_wrap}>
        <MemberName
          profile={profile}
          memberInfo={memberInfo}
          displayNameClassName={styles.display_name}
          addProfileLink={false}
          singleLine
        />
      </div>
    </div>
  </div>
);

IdentitySection.defaultProps = {
  memberInfo: undefined,
};

export default IdentitySection;
